import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-navy-50 py-14 sm:py-20" data-id="element-280" data-mp="3fy2z7vpm7s3i">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-281" data-mp="3b0udjl59d5xi">
        <SectionHeading eyebrow="Cosa dicono i professionisti" title="Un modo migliore per organizzare la conoscenza sulla TRT" subtitle="“Non ho bisogno di un altro posto dove conservare informazioni. Ho bisogno di trovare l’informazione giusta quando sono davanti a un paziente.”" data-id="element-282" data-mp="3b0az4eetgzo8" />

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-283" data-mp="2s1q9yrwhk4d8">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-navy-900/10 bg-white p-5" data-id="element-284" data-mp="v9g9bl2obyo3">
              <div className="flex items-center gap-1" aria-label="Valutazione 5 su 5" data-id="element-285" data-mp="qb51tgzuq091">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-286" data-mp="m5kjyikz0j9s" data-mpi={i} />)}
              </div>

              <QuoteIcon className="mt-3 h-6 w-6 text-navy-900/15" aria-hidden="true" data-id="element-287" data-mp="c7wp7snd7brm" />

              <blockquote className="mt-2 text-[14px] leading-relaxed text-navy-900/80 sm:text-[15px]" data-id="element-288" data-mp="zx7qdb8mn86a">
                {item.quote}
              </blockquote>

              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-289" data-mp="q5lah1lcgkx7">
                <img src={item.photo} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-gold-500/40" width={96} height={96} loading="lazy" data-id="element-290" data-mp="v5fy8w9toue1" />
                <span data-id="element-291" data-mp="1xhr01ufqu2wn">
                  <span className="block text-[14px] font-black text-navy-900" data-id="element-292" data-mp="1xgxzxcbaibnh">
                    {item.name}
                  </span>
                  <span className="block text-[12px] font-semibold text-navy-900/55" data-id="element-293" data-mp="1sgtf5a3cmurg">
                    {item.role}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-294" data-mp="1ejodrnekyk2j">
          <CtaBlock label="Unisciti a loro — 19 EUR" note="Accesso digitale immediato · Garanzia 7 giorni" data-id="element-295" data-mp="1ekfzm6idl3fm" />
        </div>
      </div>
    </section>;
}